// @flow

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { logout } from '../../Redux/Actions/Account'
import AlfredHelper from '../../Helpers/AlfredHelper'

function UserControls () {
  const dispatch = useDispatch()

  const redirect = useSelector(state => state.account.redirect)
  const subdomain = useSelector(state => state.account.subdomain)

  const logoutApp = (redirect) => {
    dispatch(logout())
    const redirectUrl = subdomain
      ? `https://${subdomain}.theemployeeapp.com`
      : redirect
    window.location.replace(redirectUrl)
  }

  const handleContactUs = () => {
    const w = window.innerWidth > 500 ? 500 : 375
    const h = 600
    const top = window.top.outerHeight / 2 + window.top.screenY - (h / 2)
    const left = window.top.outerWidth / 2 + window.top.screenX - (w / 2)
    const alfredUrl = AlfredHelper.buildAlfredUrl('customer-care')

    /**
     * Opens up a new window with alfred in center
     */
    window.open(alfredUrl, '', `toolbar=no,location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=${w}, height=${h}, top=${top}, left=${left}`)
  }

  return (
    <div id='user'>
      <button onClick={() => logoutApp(redirect)}> Logout</button>
      <button onClick={() => handleContactUs()}> Contact Us</button>
    </div>
  )
}

export default UserControls
